import React, { useState } from 'react';
import Button from '../Button/Button';
import processDocument from '../../api/bank/processDocument';
import alert from '../../helpers/alert';

const ProcessDocumentButton = ({ chunkId, text = "Повторно отправить документы", buttonProps = {} }) => {
  const [loading, setLoading] = useState(false);
  
  const handleProcessDocument = async () => {
    if (!chunkId) {
      alert.error('chunkId не найден');
      return;
    }
    
    setLoading(true);
    try {
      await processDocument(chunkId);
      alert.success('Документы успешно отправлены');
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'Ошибка при отправке документов';
      alert.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  
  
  return (
    <Button 
      text={text}
      fill
      onClick={handleProcessDocument}
      {...buttonProps}
      loading={loading}
      disabled={loading}
    />
  );
};

export default ProcessDocumentButton; 